module.exports = __webpack_public_path__ + "img/MEDITECH.810fa906.png";